module.exports = __webpack_public_path__ + "wirewax-offline/8201557/static/media/greySpinner.11c2b7e2.svg";